export const COLORS = {
  black: '#000000',
  white: '#FFFFFF',
  mint: '#00FFC6',
  blue: '#0066FF',
  gray: '#9CA3AF',
  lightGray: '#F7F7F7',
  darkGray: '#6B7280',
  greenBtn: '#00E676',
  blueGradientStart: '#0066FF',
  blueGradientEnd: '#00A3FF',
  mintGlow: '#00FFC680'
};

